<template>
  <div class="my-warning">
    <span class="title">情况总览</span>
    <div class="my-warning-body">
      <div class="search-content">
        <div class="select-searchmain1">
          <div class="earch-input">
            <div class="input-li2">
              <!-- <p>提醒日期</p> -->
              <el-date-picker
                size="small"
                style="width: 100%"
                v-model="dates"
                value-format="yyyy-MM"
                type="monthrange"
                :clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
            <div class="input-li2">
              <span>辖区：</span>
              <el-select
                size="small"
                filterable
                clearable
                v-model="searchParams.jurisdiction"
                placeholder="请选择辖区"
              >
                <el-option
                  v-for="item in jurisdiction"
                  :key="item.Key"
                  :label="item.Value"
                  :value="item.Key"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="search-action">
            <el-button
              size="small"
              icon="el-icon-search"
              type="primary"
              @click="getList()"
              >查询</el-button
            >
            <!-- <el-button size="small" icon="el-icon-refresh" plain @click="onReset()">重置</el-button> -->
          </div>
        </div>
      </div>

      <div class="chart-content">
        <el-radio-group @change="toogleChart" v-model="chartType" size="medium">
          <el-radio-button label="柱状图"></el-radio-button>
          <el-radio-button label="折线图"></el-radio-button>
          <el-radio-button label="饼图"></el-radio-button>
        </el-radio-group>

        <div class="div-charts">
          <div id="charts-main" style="width: 100%; height: 100%"></div>
          <!-- <div v-show="chartType == '饼图'" id="chart-pie" style="width: 100%; height:100%"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      searchParams: {
        startDate: "",
        endDate: "",
        jurisdiction: "",
      },
      barData: [],
      pieData: {},
      dates: [],
      jurisdiction: [],
      chartType: "柱状图",
    };
  },
  methods: {
    toogleChart() {
      if (!document.getElementById("charts-main")) return false;
      echarts.init(document.getElementById("charts-main")).dispose();
      if (this.chartType == "柱状图" || this.chartType == "折线图") {
        this.drawBarChart();
      } else {
        this.drawPieChart();
      }
    },
    getList() {
      if (this.dates && this.dates.length > 0) {
        this.searchParams.startDate = this.dates[0];
        this.searchParams.endDate = this.dates[1];
      } else {
        this.searchParams.startDate = this.searchParams.endDate = null;
      }

      const params = {
        ...this.searchParams,
      };
      const url = this.$api.warnings.getWarningStatistics;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { pieData, barData } = res.data.data;

          this.barData = barData;
          this.pieData = pieData;
          this.toogleChart();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getParams() {
      const url = this.$api.warnings.getParams;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          let { jurisdiction } = res.data.data;

          this.jurisdiction = jurisdiction;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    drawBarChart() {
      let data = this.barData;

      const chartType = this.chartType == "柱状图" ? "bar" : "line";
      const options = {
        color: ["#E6A23C", "#F56C6C", "#909399"],
        title: {
          // text: '预警/警报总览'
        },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: data.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        legend: {},
        // toolbox: {
        //   feature: {
        //     // dataView: { show: true, readOnly: false },
        //     magicType: {
        //       //动态类型切换
        //       show: true, //是否显示该工具
        //       type: ["line", "bar", "stack"], //启用的动态类型
        //       title: {
        //         line: "切换为折线图",
        //         bar: "切换为柱状图",
        //         stack: "切换为堆叠",
        //       },
        //     },
        //     restore: { show: true, title: "还原" },
        //     // saveAsImage: { show: true }
        //   },
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
          valueFormatter: function (value) {
            return value + " 条";
          },
        },
        dataset: {
          source: data,
        },
        xAxis: {
          type: "category",
          axisPointer: {
            type: "shadow",
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}条",
          },
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [{ type: chartType }, { type: chartType }, { type: chartType }],
      };
      const chartsDom = echarts.init(document.getElementById("charts-main"));
      chartsDom.setOption(options);
    },
    drawPieChart() {
      let data = [];
      for (let obj in this.pieData) {
        data.push({ name: obj, value: this.pieData[obj] });
      }
      const options = {
        color: ["#909399", "#E6A23C", "#F56C6C"],

        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "预警/警报总览",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },

            label: {
              show: true,
              normal: {
                formatter: "{b}\n \n{d}%\t{c}条",
                textStyle: {
                  fontSize: 16,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
              length2: 100,
              length: 40,
              lineStyle: {
                color: "#DDDDDD",
              },
            },
            data,
          },
        ],
      };
      const chartsDom = echarts.init(document.getElementById("charts-main"));

      chartsDom.setOption(options);
    },
  },

  mounted() {
    // 获取当前年份和月份
    const currentMonth = this.$dayjs().format("YYYY-MM");
    // 获取上个月的年份和月份
    const lastMonth = this.$dayjs().subtract(1, "month").format("YYYY-MM");

    this.dates.push(lastMonth, currentMonth);
    this.getParams();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.my-warning {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .my-warning-body {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .chart-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: calc(100% - 80px);

      .div-charts {
        width: 100%;
        margin-top: 10px;
        height: calc(100% - 50px);
      }
    }
  }

  .select-searchmain1 {
    width: 100%;
    height: 70px;
    display: flex;
    padding: 5px;
    box-sizing: content-box;

    .search-action {
      display: inline-block;
      // width: 230px;
      text-align: center;
      height: 100%;
      // line-height: 70px;
    }

    .earch-input {
      flex-grow: 1;
      padding-left: 20px;

      p {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }

      .input-li2 {
        margin-right: 20px;
        width: 350px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }

      .input-li {
        margin-right: 20px;
        width: 200px;
        font-size: 12px;
        display: inline-block;

        .el-input {
          line-height: 40px;
        }
      }
    }
  }
}
</style>